<template>
  <div class="ai-table-message">
    <AgGridVue
      class="ai-table-message__grid"
      :column-defs="columnDefs"
      :row-data="tableData.rows"
      :grid-options="inlineGridOptions"
      @grid-ready="onInlineGridReady"
    />
    <v-btn
      class="ai-table-message__expand-btn"
      data-id-e2e="aiTableExpandBtn"
      icon
      size="x-small"
      variant="tonal"
      title="Expand table"
      @click="showDialog = true"
    >
      <v-icon size="16">mdi-fullscreen</v-icon>
    </v-btn>

    <!-- ai-dialog--full-viewport: opt out of the panel-offset restriction so the
         dialog scrim covers the full viewport rather than just the content area. -->
    <v-dialog
      v-model="showDialog"
      max-width="90vw"
      class="ai-dialog--full-viewport"
      data-id-e2e="aiTableDialog"
    >
      <BaseDialogCard :title="tableData.title || 'Table'" @close="showDialog = false">
        <AgGridVue
          class="ai-table-message__dialog-grid"
          :column-defs="columnDefs"
          :row-data="tableData.rows"
          :grid-options="dialogGridOptions"
          @grid-ready="onDialogGridReady"
        />
        <template #footer>
          <v-card-actions>
            <v-spacer />
            <v-btn
              secondary
              variant="flat"
              class="outlined-btn"
              prepend-icon="mdi-download"
              @click="downloadCsv"
            >
              Download CSV
            </v-btn>
          </v-card-actions>
        </template>
      </BaseDialogCard>
    </v-dialog>
  </div>
</template>

<script setup>
import { ref, computed } from 'vue';
import BaseDialogCard from '@/components/BaseDialogCard.vue';

const props = defineProps({
  tableData: {
    type: Object,
    required: true,
  },
});

const inlineGridApi = ref(null);
const dialogGridApi = ref(null);
const showDialog = ref(false);

// Map the LLM's simple column type to ag-grid filter/type configuration.
function colDefForColumn(col) {
  const base = {
    field: col.field,
    headerName: col.headerName,
    resizable: true,
    sortable: true,
    minWidth: 80,
  };
  if (col.type === 'number') {
    return { ...base, filter: 'agNumberColumnFilter' };
  }
  if (col.type === 'date') {
    return { ...base, filter: 'agDateColumnFilter' };
  }
  return { ...base, filter: 'agTextColumnFilter' };
}

const columnDefs = computed(() => (props.tableData.columns || []).map(colDefForColumn));

const inlineGridOptions = {
  suppressContextMenu: true,
  headerHeight: 32,
  rowHeight: 28,
  domLayout: 'normal',
  defaultColDef: { filter: false, resizable: true },
};

const dialogGridOptions = {
  suppressContextMenu: true,
  headerHeight: 36,
  rowHeight: 32,
  domLayout: 'normal',
};

function onInlineGridReady(params) {
  inlineGridApi.value = params.api;
  params.api.sizeColumnsToFit();
}

function onDialogGridReady(params) {
  dialogGridApi.value = params.api;
  params.api.sizeColumnsToFit();
}

function downloadCsv() {
  dialogGridApi.value?.exportDataAsCsv({
    fileName: props.tableData.title || 'table-export',
  });
}
</script>

<style scoped>
.ai-table-message {
  position: relative;
  width: 100%;
}

.ai-table-message__grid {
  width: 100%;
  height: 220px;
}

.ai-table-message__dialog-grid {
  width: 100%;
  height: 600px;
}

.ai-table-message__expand-btn {
  position: absolute;
  bottom: 8px;
  right: 8px;
  opacity: 0.65;
  transition: opacity 0.15s;
}

.ai-table-message:hover .ai-table-message__expand-btn {
  opacity: 1;
}
</style>
